import { Box, useDisclosure } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { Text } from "./Text";
import { useColors } from "./useColors";

export const Spoiler = ({
  about,
  box,
  children,
}: PropsWithChildren<{ about?: string; box?: boolean }>) => {
  const { isOpen, onToggle } = useDisclosure();
  const {
    footnoteBackground,
    footnoteBackgroundHover,
    subtitleColor,
    textColor,
  } = useColors();

  return (
    <Box
      as={box ? "div" : "span"}
      bg={isOpen ? "transparent" : footnoteBackground}
      _hover={{
        bg: isOpen ? "transparent" : footnoteBackgroundHover,
      }}
      transition="background 0.2s ease"
      borderBottomWidth="1px"
      borderColor={textColor}
      borderStyle="dotted"
      cursor="pointer"
      onClick={(e: React.MouseEvent) => {
        if ((e.target as HTMLElement).tagName !== "A") {
          onToggle();
        }
      }}
    >
      {about && (
        <Text
          as="span"
          color={subtitleColor}
          fontFamily="sans"
          fontWeight="normal"
          ml={0.5}
          mr={1}
        >
          (spoilers for {about})
        </Text>
      )}
      <Text
        as={box ? "div" : "span"}
        transition="color 0.2s ease"
        sx={
          isOpen
            ? {}
            : {
                "&, & *": {
                  bg: "transparent !important",
                  color: "transparent !important",
                  pointerEvents: "none",
                },
              }
        }
      >
        {children}
      </Text>
    </Box>
  );
};
